"use client";

import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import Bounded from "@/components/componentsV2/shared-components/Bounded";
import EngageHelpCard from "@/app/(landing)/mental-health/components/engage-help-card";
import customPageLeftShape from "@/assets/common/customPageLeftShape.svg";
import customPageRightShape from "@/assets/common/customPageRightShape.svg";
import Image from "next/image";
import { motion } from "framer-motion";

/**
 * Props for `EngagementDevelopmentSection`.
 */
export type EngagementDevelopmentSectionProps =
  SliceComponentProps<Content.EngagementDevelopmentSectionSlice>;

/**
 * Component for "EngagementDevelopmentSection" Slices.
 */
const EngagementDevelopmentSection: FC<EngagementDevelopmentSectionProps> = ({
  slice,
}) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {slice.variation === "default" ? (
        <div className="bg-primary relative overflow-hidden">
          <Bounded className="py-20">
            {/* heading */}

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              <h1 className="text-white md:text-center text-4xl lg:text-5xl font-semibold mb-8">
                {slice.primary.heading}
              </h1>
            </motion.div>

            {/* cards */}

            <motion.div
              className="space-y-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              {slice.primary.engagement_help_cards.map((item, index) => (
                <EngageHelpCard key={index} data={item} />
              ))}
            </motion.div>
          </Bounded>

          {/* overlays */}

          <Image
            src={customPageLeftShape.src}
            alt="left shape"
            width={710.44}
            height={659.7}
            className="absolute left-0 -top-20 h-[404px] w-auto pointer-events-none"
          />

          <Image
            src={customPageRightShape.src}
            alt="right shape"
            width={710.44}
            height={659.7}
            className="absolute right-0 bottom-0 h-[404px] w-auto hidden md:block pointer-events-none"
          />

          <div className="absolute bg-[#43D9BD] blur-[137px] h-[275px] w-[275px] rounded-full right-[-125px] top-[-100px]" />

          <div className="absolute bg-[#43D9BD] blur-[102px] h-[260px] w-[260px] rounded-full bottom-[-130px] left-[-97px]" />
        </div>
      ) : null}
    </section>
  );
};

export default EngagementDevelopmentSection;
